import { combineReducers } from 'redux';

import { busylightReducer } from 'app/views/layout/views/settings/views/preferences/views/preferencesConnectedDevices/views/busylight/busylight.reducer';
import { profileReducer } from 'app/views/layout/views/settings/views/profile/settingsProfile.reducer';

import { organization as organizationV2 } from '../organization/reducers/organization';

import { chatWidget } from './sections/chatWidgets';
import { email } from './sections/email';
import { organization } from './sections/organization';
import { personal } from './sections/personal';
import { queues } from './sections/queues';
import { satisfaction } from './sections/satisfaction';
import { telephony } from './sections/telephony';
import { templates } from './sections/templates';

const reducer = combineReducers({
  profile: profileReducer,
  organization,
  organizationV2,
  queues,
  telephony,
  chatWidget,
  personal,
  email,
  satisfaction,
  templates,
  busylight: busylightReducer,
});

export default reducer;
